import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CommentProvider } from './context/comment';
import { PostProvider } from './context/post';
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from './context/auth';
import { UserProvider } from './context/user';
import { SocketContextProvider } from './context/SocketContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <AuthProvider>
      <PostProvider>
        <CommentProvider>
          <UserProvider>
            <SocketContextProvider>
            <App />
            </SocketContextProvider>
          </UserProvider>
        </CommentProvider>
      </PostProvider>
    </AuthProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
